import React, { FunctionComponent, useState, useEffect } from 'react';
import { Presentation } from './presentation';
import { RecruitmentShowContentInfoProps as Props, RecruitmentShowContentInfoState } from './types';
import { showRecruitmentPageHeading } from '../../../services/recruitments';

export const Component: FunctionComponent<Props> = (props) => {
  const [state, setState] = useState<RecruitmentShowContentInfoState>({ companyId: null, salary: '', salaryDetail: '' });

  useEffect(() => {
    const request = async () => {
      try {
        const response = await showRecruitmentPageHeading(props.recruitmentId);
        setState(prev => ({
          ...prev,
          companyId: response.companyId ?? null,
          salary: response.salary,
          salaryDetail: response.salaryDetail,
          salarySearchUrl: response.salarySearchUrl,
          icon: response.icon,
          company_name: response.company_name,
          recruitment_title: response.recruitment_title,
          employment_types: response.employment_types,
          regularEmployee: response.regularEmployee,
          address: response.address,
          prefectureEnName: response.prefectureEnName,
        }));
      } catch (error) {
        console.log(error);
      }
    };
    request();
  }, [props.recruitmentId]);

  return (
    <Presentation
      state={state}
      {...props}
    />
  );
};
